import { render, staticRenderFns } from "./_evontt.vue?vue&type=template&id=18fad2ee&lang=pug&"
import script from "./_evontt.vue?vue&type=script&lang=js&"
export * from "./_evontt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports